import md5 from 'md5';
import { useEffect, useMemo } from 'react';
import { useStorageState } from 'react-storage-hooks';

interface ImageCachedProps {
  videoUrl: string;
  isCustomVideo?: boolean;
  isVideoPlayed?: boolean;
}

export const useVideoCached = ({ videoUrl = '', ...props }: ImageCachedProps): [boolean] => {
  const [cachedVideos, setVideoCached] = useStorageState<string[]>(
    sessionStorage,
    'VIDEOS-CACHED',
    [],
  );
  const hashedVideo = useMemo(() => md5(JSON.stringify({ videoUrl })), [videoUrl]);
  const isVideoCached = useMemo(
    () => !!cachedVideos.find((hash) => hashedVideo === hash),
    [cachedVideos, hashedVideo],
  );

  useEffect(() => {
    if (isVideoCached) return;
    if (!props?.isCustomVideo) return;
    if (!props?.isVideoPlayed) return;

    setVideoCached((prev) => [...prev, hashedVideo]);
  }, [
    hashedVideo,
    isVideoCached,
    setVideoCached,
    props?.isCustomVideo,
    props?.isVideoPlayed,
    videoUrl,
  ]);

  return [isVideoCached];
};
